import { useEffect, useState } from "react";

export function useInstallPrompt() {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const displayMode = globalThis.matchMedia?.("(display-mode: standalone)");
    const updateInstalled = () => setInstalled(displayMode?.matches || globalThis.navigator?.standalone === true);
    updateInstalled();
    const capture = event => { event.preventDefault(); setPrompt(event); };
    const complete = () => { setInstalled(true); setPrompt(null); };
    displayMode?.addEventListener?.("change", updateInstalled);
    globalThis.addEventListener("beforeinstallprompt", capture);
    globalThis.addEventListener("appinstalled", complete);
    return () => {
      displayMode?.removeEventListener?.("change", updateInstalled);
      globalThis.removeEventListener("beforeinstallprompt", capture);
      globalThis.removeEventListener("appinstalled", complete);
    };
  }, []);

  return {
    installed,
    available: Boolean(prompt),
    install: async () => {
      if (!prompt) return false;
      await prompt.prompt();
      const result = await prompt.userChoice;
      if (result.outcome === "accepted") setPrompt(null);
      return result.outcome === "accepted";
    }
  };
}
